var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_STORES = 'api/store';
const GET_SET_STORES_V2 = 'api/v2/stores';
const REQUEST_PARAMS = {
    token: 'LOGGED_USER_TOKEN',
};
export const updateStoreById = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_STORES}/${storeId}`, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error fetching getStoreById:', error);
            throw error;
        }
    });
};
export const deleteStoreById = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.delete(`${GET_SET_STORES}/${storeId}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching deleteStoreById:', error);
            throw error;
        }
    });
};
export const setOrderSequence = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_STORES_V2}/${storeId}/settings/order-sequence`, data, config);
        }
        catch (error) {
            console.error('Error fetching setOrderSequence:', error);
            throw error;
        }
    });
};
export const updatePaymentFees = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_STORES_V2}/${storeId}/payment-fees`, data, config);
        }
        catch (error) {
            console.error('Error fetching updatePaymentFees:', error);
            throw error;
        }
    });
};
